import {
  crownItemSchema,
  getBaseProductSchema,
  ItemTypeEnum,
  productMaterialCharacteristicsSchema,
  productPreferencesSchema,
  ProductTypeEnum,
  type SplintedCrownProduct,
} from "@jasper/client-models";
import {
  isTeethStepComplete,
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { MaterialStep, PreferencesStep, CrownTeethStep } from "./constants";

export type SplintedCrownStepKey =
  | typeof StepKeysEnum.crownTeeth
  | typeof StepKeysEnum.material
  | typeof StepKeysEnum.preferences;

export const SplintedCrownWorkflowConfiguration: ProductWorkflowConfiguration<
  SplintedCrownProduct,
  SplintedCrownStepKey
> = {
  productType: ProductTypeEnum.splintedCrown,
  itemType: ItemTypeEnum.crown,
  steps: [
    new CrownTeethStep({ type: "FIXED" }),
    new MaterialStep(),
    new PreferencesStep(),
  ],
  teethSelection: TeethSelectionEnum.MIXED,
  isBulkSupported: true,
  isBulkCompatible: (_leaderProduct, followerProduct) =>
    followerProduct.type === ProductTypeEnum.splintedCrown ||
    followerProduct.type === ProductTypeEnum.crown,

  isValidProduct(product) {
    return getBaseProductSchema({ itemSchema: crownItemSchema }).safeParse(
      product
    ).success;
  },

  getCompletedSteps(product) {
    const completed: SplintedCrownStepKey[] = [];

    if (
      isTeethStepComplete({
        teeth: product.teeth,
        teethSelection: this.teethSelection,
      })
    ) {
      completed.push(StepKeysEnum.crownTeeth);
    }

    const isMaterialStepComplete =
      productMaterialCharacteristicsSchema.safeParse(product).success;

    if (product.items?.length && isMaterialStepComplete) {
      completed.push(StepKeysEnum.material);
    }

    const isPreferencesStepComplete =
      productPreferencesSchema.safeParse(product).success;

    if (isPreferencesStepComplete) {
      completed.push(StepKeysEnum.preferences);
    }

    return completed;
  },
};
